var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { getStatusTranslation } from "../utils/getStatusTranslation";
/**
 * Columns of the publisher prefix list.
 *
 * @param onRowClick opens the prefix detail
 * @param isPublisherGuarantor a publisher-only user sees its own prefixes without range and publisher
 * @param publicOnlyView the public-only view (e.g. collections administrator) gets no numbering state
 *   and declaration columns — the backend does not return them to it (DB-837)
 */
export var usePublisherPrefixTable = function (onRowClick, isPublisherGuarantor, publicOnlyView) {
    if (isPublisherGuarantor === void 0) { isPublisherGuarantor = false; }
    if (publicOnlyView === void 0) { publicOnlyView = false; }
    var intl = useIntl();
    var formatMessage = useIntl().formatMessage;
    var columns = useMemo(function () { return __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix.table.columns.agencyPrefix",
            }),
            key: "publisher",
            cellRenderer: function (item) {
                var _a, _b, _c;
                if (!((_a = item.publisherPrefixRange) === null || _a === void 0 ? void 0 : _a.agencyPrefix))
                    return "";
                var agencyPrefix = item.publisherPrefixRange.agencyPrefix;
                return "".concat(((_b = agencyPrefix.internationalPrefix) === null || _b === void 0 ? void 0 : _b.agency) || "", " ").concat(((_c = agencyPrefix.internationalPrefix) === null || _c === void 0 ? void 0 : _c.value) || "", "-").concat(agencyPrefix.value || "").trim();
            },
        }
    ], (isPublisherGuarantor
        ? []
        : [
            {
                name: formatMessage({
                    id: "ui-br-agency.publisher-prefix.table.columns.publisherPrefixRange",
                }),
                key: "publisherPrefixRange",
                cellRenderer: function (item) {
                    if (!item.publisherPrefixRange)
                        return "";
                    var range = item.publisherPrefixRange;
                    return "".concat(range.start || "", "-").concat(range.end || "");
                },
            },
        ]), true), [
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix.table.columns.value",
            }),
            key: "value",
            clickable: !isPublisherGuarantor,
            onClick: !isPublisherGuarantor ? onRowClick : undefined,
        }
    ], false), (isPublisherGuarantor
        ? []
        : [
            {
                name: formatMessage({
                    id: "ui-br-agency.publisher-prefix.table.columns.publisher",
                }),
                key: "publisher",
                cellRenderer: function (item) {
                    var _a;
                    return ((_a = item.publisher) === null || _a === void 0 ? void 0 : _a.name) || "";
                },
            },
        ]), true), [
        {
            name: formatMessage({
                id: "ui-br-agency.publisher-prefix.table.columns.status",
            }),
            key: "status",
            width: "90px",
            cellRenderer: function (item) { return getStatusTranslation(intl, item.status); },
        }
    ], false), (publicOnlyView
        ? []
        : [
            {
                name: formatMessage({
                    id: "ui-br-agency.publisher-prefix.table.columns.declarationStatus",
                }),
                key: "declarationStatus",
                width: "150px",
                cellRenderer: function (item) {
                    return item.declarationStatus
                        ? formatMessage({
                            id: "ui-br-agency.publisher-prefix.declarationStatus.".concat(item.declarationStatus),
                        })
                        : "";
                },
            },
            {
                name: formatMessage({
                    id: "ui-br-agency.publisher-prefix.table.columns.nextSequence",
                }),
                key: "nextSequence",
            },
        ]), true); }, [formatMessage, onRowClick, isPublisherGuarantor, publicOnlyView]);
    return { columns: columns };
};
